import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Team } from '../team.model';
import { TeamService } from '../team.service';

@Component({
  selector: 'app-team-edit',
  templateUrl: './team-edit.component.html',
  styleUrls: ['./team-edit.component.css']
})
export class TeamEditComponent implements OnInit {

  public teamForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<TeamEditComponent>,
    @Inject(MAT_DIALOG_DATA) public team: Team,
    private fb: FormBuilder,
    private teamService: TeamService) {
    this.createForm();
  }

  ngOnInit() {
  }

  createForm() {
    this.teamForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern(/^[a-zA-Z ()\s]*$/)]]
    });

    this.teamForm.setValue({
      name: this.team.name
    });
    }

  sanitizeInput(event: any) {
      event.target.value = event.target.value.replace(/[^a-zA-Z ()\s]/g, '');
  }

  onSubmit() {
    this.team = this.prepareSaveTeam();
    this.teamService.updateTeam(this.team.id, this.team)
      .then(result => this.dialogRef.close(result))
      .catch(error => console.log(error));
    this.teamForm.setValue({
      name: this.team.name
    });
  }

    prepareSaveTeam(): Team {
    const formModel = this.teamForm.value;
    var saveTeam = new Team;
    saveTeam.id = this.team.id;
    saveTeam.name = formModel.name;
    saveTeam.partnerCount = this.team.partnerCount;
    saveTeam.loggedInUserEmail = this.team.loggedInUserEmail;
    return saveTeam;
  }
}





// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/teams/team-edit/team-edit.component.ts